<template>
  <GrupoLeyendaCheck
    titulo="Población"
    checkboxType="switch"
    v-model="poblacion_expanded"
  >
    <label v-width-control="'60%'" class="radio">
        <input type="radio" value="localidad" v-model="nivel_seleccionado">
        <span>Nivel localidad</span>
    </label>
    <BotonMasInfo  v-width-control="'45%'" @click="masInfoLocalidades"/>
    <div class="leyendas-combinadas" :style="{display:nivel_seleccionado==='localidad'? '':'none'}">
      <DaiLeyendaMapa para="poblacion_localidades_puntos" v-width-control="'10%'" class="leyenda-solo-muestra-figura" :tamanosDeMapa="true" />
      <DaiLeyendaMapa para="poblacion_localidades" v-width-control="'90%'" />
    </div>
    <hr class="dai-map-separator thin" />
    
    <div class="pt-2">
      <label v-width-control="'60%'" class="radio">
        <input type="radio" value="municipio" v-model="nivel_seleccionado">
        <span>Nivel Municipio</span>
      </label>
      <BotonMasInfo  v-width-control="'45%'" @click="masInfoMunicipios" />  
    </div>       
    <DaiLeyendaMapa para="poblacion_municipios" :style="{display:nivel_seleccionado==='municipio'? '':'none'}" />
    
  </GrupoLeyendaCheck>
</template>

<script>
import GrupoLeyendaCheck from "./utils/GrupoLeyendaCheck.vue";
import BotonMasInfo from "./utils/BotonMasInfo.vue";

import { scrollTo } from "@/components/_utils.js";

export default {
  components: {
    GrupoLeyendaCheck,
    BotonMasInfo
  },
  data(){
      return {
          
      }
  },
  computed: {
    poblacion_expanded: {
      get() {
        return this.$store.state.mapa.temasExpandidos.poblacion;
      },
      set(expandido) {
        this.$store.commit("mapa/setTemasExpandidos", {
          tema: "poblacion",
          expandido: expandido,
        });
      },
    },
    nivel_seleccionado:{
        get(){
            return this.$store.state.mapa.poblacionNivelSeleccionado;
        },
        set(nivel){
            this.$store.commit("mapa/setPoblacionNivelSeleccionado",nivel)
        }
    }
  },
  methods:{
    masInfoLocalidades(){
      this.$store.commit("mapa/setFichaActiva", "poblacion"); //el de poblacion es default para localidades
      scrollTo(document.querySelector("[data-section='fichas']"),-102);
    },
    masInfoMunicipios(){
      this.$store.commit("mapa/setFichaActiva", "poblacion_municipios");
      scrollTo(document.querySelector("[data-section='fichas']"),-102);
    }
  }
};
</script>

<style lang="scss" scoped>
.pt-2 {
  width: 100%;
  display: flex;
  padding-top: 16px;
}
label.radio{
    font-size: 14px;
    display: flex;
    align-items: center;
    cursor: pointer;
}
input[type="radio"]{
    background-color: var(--control-bg-color);
    font-size: inherit;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    border: 1px solid var(--control-color);
    cursor: pointer;
    margin-right: 0.5em;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 1.5em 1.5em;
    flex-grow: 0;
    margin-bottom: 0;
    margin-top: 0;
    margin-left: 0;
    &:checked{
        background-image: url('data:image/svg+xml,<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="37"/></svg>');
        background-size: auto;
    }
}
</style>

<style lang="scss">
.leyendas-combinadas{
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    //padding-left: .5em;
    .leyenda-solo-muestra-figura{
        .header-legend{
            display: none; 
        }
        .legend-normal-vector{
            input,.custom-checkbox{
                display: none;
            }
            .dai-checkbox-container{
                flex-direction: column;
                .dai-map-shape.simbologia{
                    margin-bottom: 18px;
                    margin-top: 18px
                }
                span{
                    font-size: 11px;
                    font-weight: 500;
                }
            }
        }
        &div.main-legend{
            padding-left: 0;
        }
    }

    .map-legends[data-layer='poblacion_localidades']{
        .map-legend-item{
            .map-legends-item-text{
                font-size: 11px;
            }
        }
    }
    .main-legend{
        padding-left: 0;
    }
}
.map-legends .map-legend-item {
  justify-content: flex-start !important;
}
</style>